'use strict';

module.exports = function(
  $scope,
  $state,
  $timeout,
  gettextCatalog,
  Notification,
  Object,
  ObjectModel,
  officeResolve,
  resourceResolve,
  SyncDA,
  AppointmentDA,
  UserSession,
  ResourceDA,
) {
  $scope.resource = resourceResolve;
  $scope.office = officeResolve;
  $scope.weekDays = [];

  $scope.reasons = [
    {
      key: 'other',
      text: gettextCatalog.getString('other'),
    },
    {
      key: 'holiday',
      text: gettextCatalog.getString('holiday'),
    },
    {
      key: 'ill',
      text: gettextCatalog.getString('ill'),
    },
    {
      key: 'pd',
      text: gettextCatalog.getString('pd'),
    },
  ];

  /**
   * generate private calendar address
   */
  var generateCalendarAddress = function() {
    var base =
      location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');

    if ($scope.resource._id && $scope.resource.ical) {
      $scope.icalUrl = base + '/api/v2/calendar/ical/' + $scope.resource.ical + '/feed.ics';
    }
  };

  var loadSyncs = function() {
    if ($scope.resource._id) {
      SyncDA.get($scope.resource._id).then(function(response) {
        $scope.syncs = response.syncList;
      });
    }
  };

  /**
   * generate resource image preview
   * @param $files
   */
  $scope.onResourceImageSelect = function($files) {
    if (angular.isArray($files) && $files.length > 0) {
      var file = $files[0];
      $scope.$files = $files;

      if (window.FileReader && file.type.indexOf('image') > -1) {
        var fileReader = new FileReader();

        fileReader.readAsDataURL(file);
        fileReader.onload = function(event) {
          $timeout(function() {
            $scope.imagePreview = event.target.result;
          });
        };
      }
    }
  };

  if ($scope.resource.image) {
    $scope.imagePreview = 'files/employees/' + $scope.resource.image;
  } else {
    switch ($scope.resource.salutation) {
      case 'm':
        $scope.imagePreview = '/img/employee_man.png';
        break;
      case 'f':
        $scope.imagePreview = '/img/employee_woman.png';
        break;
      default:
        $scope.imagePreview = '/img/employee_woman.png';
        break;
    }
  }

  /**
   * concat firstname and lastname to "lastname, firstname"
   */
  $scope.concatName = function() {
    var nameParts = [];

    if ($scope.resource.lastname) {
      nameParts.push($scope.resource.lastname);
    }

    if ($scope.resource.firstname) {
      nameParts.push($scope.resource.firstname);
    }

    $scope.resource.name = nameParts.join(', ');
  };

  /**
   * generate an array with n elements for ng-repeat loop
   * @param n
   * @returns {Array}
   */
  $scope.getNumber = function(n) {
    return new Array(n);
  };

  /**
   * add/remove a second column to working hour table
   * @param day
   */
  $scope.adjustWorkingTime = function(day) {
    if ($scope.resource.workingHours[day].times.length === 1) {
      var firstEndTime = $scope.resource.workingHours[day].times[0].end;

      $scope.resource.workingHours[day].times.push({
        start: firstEndTime + 60 > 1440 ? 1440 : firstEndTime + 60,
        end: firstEndTime + 240 > 1440 ? 1440 : firstEndTime + 240,
      });
    } else {
      $scope.resource.workingHours[day].times.splice(1, 1);
    }
  };

  $scope.save = function() {
    if (!$scope.resource._id) {
      $scope.resource.type = 'employee';

      var resource = new Object($scope.resource);

      ObjectModel.save(resource, function(error, response) {
        if (error) {
          Notification.addErrorMessage(
            gettextCatalog.getString('Cant add resource (Error: {{error}})', { error: error }),
          );
        } else {
          loadSyncs();
          $scope.resource = response;
          $state.go('private.main.resourcesDetails', {
            type: $scope.resource.type,
            resourceId: $scope.resource._id,
          });
          Notification.addSuccessMessage(
            gettextCatalog.getString('{{name}} created', { name: $scope.resource.name }),
          );
        }
      });
    } else {
      if ($scope.$files) {
        ObjectModel.uploadImage($scope.$files, $scope.resource, function(error, updatedObject) {
          if (error) {
            if (error.message === 'file_to_large') {
              Notification.addErrorMessage(gettextCatalog.getString('image to big'));
            } else if (error.message === 'extension_not_allowed') {
              Notification.addErrorMessage(gettextCatalog.getString('file extension not allowed'));
            } else {
              Notification.addErrorMessage(
                gettextCatalog.getString('Cant save resource (Error: {{error}})', { error: error }),
              );
            }
          } else {
            $scope.resource = updatedObject;
            $scope.newImage = true;
            Notification.addSuccessMessage(
              gettextCatalog.getString('{{name}} updated', { name: $scope.resource.name }),
            );
          }
        });
      } else {
        ObjectModel.update($scope.resource, function(error) {
          if (error) {
            Notification.addErrorMessage(
              gettextCatalog.getString('Cant save resource (Error: {{error}})', { error: error }),
            );
          } else {
            Notification.addSuccessMessage(
              gettextCatalog.getString('{{name}} updated', { name: $scope.resource.name }),
            );
          }
        });
      }
    }
  };

  $scope.delete = function() {
    ObjectModel.delete($scope.resource, function(error) {
      if (error) {
        Notification.addErrorMessage({
          text: gettextCatalog.getString('Cant remove resource (Error: {{error}})', {
            error: error.text,
          }),
        });
      } else {
        Notification.addSuccessMessage(
          gettextCatalog.getString('{{name}} removed', { name: $scope.resource.name }),
        );
        $state.go('private.main.resources');
      }
    });
  };

  /**
   * copy opening hours to resource working hours
   */
  $scope.copyOpeningHours = function() {
    for (var i = 0, ohLen = $scope.office.openingHours.regular.length; i < ohLen; i++) {
      if ($scope.office.openingHours.regular[i].open) {
        $scope.resource.workingHours[i].available = true;

        $scope.resource.workingHours[i].times[0].start =
          $scope.office.openingHours.regular[i].times[0].start;
        $scope.resource.workingHours[i].times[0].end =
          $scope.office.openingHours.regular[i].times[0].end;

        if ($scope.office.openingHours.regular[i].times.length > 1) {
          if (!$scope.resource.workingHours[i].times[1]) {
            $scope.resource.workingHours[i].times[1] = {};
          }

          $scope.resource.workingHours[i].times[1].start =
            $scope.office.openingHours.regular[i].times[1].start;
          $scope.resource.workingHours[i].times[1].end =
            $scope.office.openingHours.regular[i].times[1].end;
        }
      } else {
        $scope.resource.workingHours[i].available = false;
      }
    }
  };

  /**
   * add an absent day
   */
  $scope.addAbsentRow = function() {
    $scope.resource.absent.push({
      start: moment().startOf('day'),
      end: moment().endOf('day'),
      reason: 'OTHER',
    });
  };

  /**
   * remove an absent day
   * @param absentDay
   */
  $scope.removeAbsentRow = function(absentDay) {
    var index = $scope.resource.absent.indexOf(absentDay);

    if (index > -1) {
      $scope.resource.absent.splice(index, 1);
    }
  };

  if ($scope.resource.ical) {
    $scope.privateCalendarAddressEnabled = true;
    generateCalendarAddress();
  }

  loadSyncs();

  /**
   * enable/disable private calendar address
   */
  $scope.changePrivateCalendarAddressEnabledState = function() {
    if ($scope.privateCalendarAddressEnabled) {
      $scope.resetPrivateAddress();
    } else {
      $scope.resource.ical = null;
      $scope.icalUrl = '';
    }
  };

  /**
   * get new private calendar address from API
   */
  $scope.resetPrivateAddress = function() {
    ResourceDA.refreshCalendarAddress($scope.resource._id)
      .then(function(response) {
        $scope.resource.ical = response.ical;
        generateCalendarAddress();
        Notification.addSuccessMessage(gettextCatalog.getString('calendar address resetted'));
      })
      .catch(function() {
        Notification.addErrorMessage(
          gettextCatalog.getString('Cant reset private calendar address'),
        );
      });
  };

  /**
   * add new external calendar
   */
  $scope.addCalendarUrl = function() {
    var syncAlreadyExists = $scope.syncs.filter(function(sync) {
      return sync.address === $scope.externalIcalAddress;
    })[0];

    if (syncAlreadyExists) {
      return Notification.addErrorMessage(
        gettextCatalog.getString('You cant subscribe to same calendar twice'),
      );
    }

    if ($scope.icalUrl === $scope.externalIcalAddress) {
      return Notification.addErrorMessage(
        gettextCatalog.getString('You cant subscribe to your own calendar in this system'),
      );
    }

    var calendarSync = {
      type: 'ical',
      address: $scope.externalIcalAddress,
      copyDescription: $scope.copyDescription,
    };

    SyncDA.insert($scope.resource._id, calendarSync).then(
      function(response) {
        $scope.externalIcalAddress = '';
        $scope.syncs.push(response.sync);
        Notification.addSuccessMessage(
          gettextCatalog.getString('Successfully subscribed to calendar'),
        );
      },
      // TODO: implement a helper function or a global error handler
      function(response) {
        var errorMsg = _.get(response, 'data.error[0].msg');
        var error;

        if (errorMsg) {
          error = gettextCatalog.getString(errorMsg);
        } else {
          error = gettextCatalog.getString('Unknown');
        }

        Notification.addErrorMessage(
          gettextCatalog.getString('Cant subscribe to calendar (Error: {{error}})', {
            error: error,
          }),
        );
      },
    );
  };

  function _removeSync(sync) {
    return SyncDA.delete($scope.resource._id, sync._id).then(
      function() {
        var index = $scope.syncs.indexOf(sync);
        $scope.syncs.splice(index, 1);
        Notification.addSuccessMessage(gettextCatalog.getString('Calendar subscription removed'));
      },
      function(error) {
        Notification.addErrorMessage(
          gettextCatalog.getString('Cant remove calendar subscription (Error: {{error}})', {
            error: error,
          }),
        );
      },
    );
  }

  $scope.updateSyncActive = function(sync) {
    return SyncDA.update($scope.resource._id, sync._id, sync).then(
      function(updatedSync) {
        var syncToUpdate = _.find($scope.syncs, ['_id', sync._id]);
        syncToUpdate.active = updatedSync.active;

        if (!syncToUpdate.active) {
          Notification.addInfoMessage(
            gettextCatalog.getString('You still can sync your calendar manually'),
          );
          Notification.addSuccessMessage(
            gettextCatalog.getString('Calendar subscription disabled'),
          );
        } else {
          Notification.addInfoMessage(
            gettextCatalog.getString(
              'Calendar events will be synced with this calendar automatically',
            ),
          );
          Notification.addSuccessMessage(gettextCatalog.getString('Calendar subscription enabled'));
        }
      },
      function(error) {
        Notification.addErrorMessage(
          gettextCatalog.getString('Cant update calendar subscription (Error: {{error}})', {
            error: error,
          }),
        );
      },
    );
  };

  $scope.updateSyncIsCopyDescription = function(sync) {
    return SyncDA.update($scope.resource._id, sync._id, sync).then(
      function(updatedSync) {
        var syncToUpdate = _.find($scope.syncs, ['_id', sync._id]);
        syncToUpdate.copyDescription = updatedSync.copyDescription;

        if (!syncToUpdate.copyDescription) {
          Notification.addInfoMessage(
            gettextCatalog.getString('Copy Appointment Description disabled'),
          );
        } else {
          Notification.addInfoMessage(
            gettextCatalog.getString('Copy Appointment Description enabled'),
          );
        }
      },
      function(error) {
        Notification.addErrorMessage(
          gettextCatalog.getString('Cant update calendar subscription (Error: {{error}})', {
            error: error,
          }),
        );
      },
    );
  };

  $scope.removeSync = function(sync) {
    if (!sync.lastSync) return _removeSync(sync);

    if ($scope.isPending(sync)) return;

    var cond = confirm(gettextCatalog.getString('Do you want to remove all related events too?'));

    if (!cond && !sync.active) return;

    if (!cond) {
      var updatedSync = _.cloneDeep(sync);
      updatedSync.active = false;

      return $scope.updateSyncActive(updatedSync);
    }

    AppointmentDA.removeSyncedViaICal($scope.resource._id, sync._id).then(function(res) {
      if (!res.success) return new Error('Cant remove associated appointments');

      Notification.addSuccessMessage(gettextCatalog.getString('Related events removed'));

      return _removeSync(sync);
    });
  };

  $scope.isPending = function(sync) {
    var date = sync && sync.lastSync;

    if (!date || sync.error > 0) return false;

    return new Date(date).valueOf() === -1;
  };

  var pendingTimeout;
  function checkPending() {
    var isNeedToRefresh =
      !$scope.syncs ||
      $scope.syncs.some(function(item) {
        return $scope.isPending(item);
      });

    if ($scope.resource._id && !isNeedToRefresh) return;

    SyncDA.get($scope.resource._id).then(function(response) {
      $scope.syncs = response.syncList;

      pendingTimeout = $timeout(checkPending, 10000);
    });
  }

  checkPending();

  $scope.$on('$destroy', function() {
    $timeout.cancel(pendingTimeout);
  });

  $scope.runSync = function(sync) {
    if ($scope.isPending(sync)) return;

    Notification.addSuccessMessage(
      gettextCatalog.getString('Please wait, calendar sync can take some time'),
    );

    sync.lastSync = new Date(-1);
    sync.error = 0;

    SyncDA.runSync($scope.resource._id, sync._id).then(
      function(updatedSync) {
        sync.lastSync = updatedSync.lastSync;
        var count = updatedSync.count;
        var message;

        if (count) {
          message =
            count > 1
              ? gettextCatalog.getString('Was added {{count}} appointments', { count: count })
              : gettextCatalog.getString('Was added one appointment');

          Notification.addSuccessMessage(message);
        }

        Notification.addSuccessMessage(gettextCatalog.getString('Calendar is synced'));
      },
      function(resource) {
        checkPending();

        var errorMsg = _.get(resource, 'data.error');

        if (errorMsg) {
          errorMsg = gettextCatalog.getString(errorMsg);
        } else {
          errorMsg = gettextCatalog.getString('Unknown');
        }

        Notification.addErrorMessage(
          gettextCatalog.getString('Cant update calendar subscription (Error: {{error}})', {
            error: errorMsg,
          }),
        );
      },
    );
  };
};



// WEBPACK FOOTER //
// ./src/app/modules/resources/ResourcesEmployeeDetailsCtrl.js